<template>
    <q-knob
        :min="min"
        :max="max"
        size="33px"
        color="white"
        track-color="red"
        readonly
        @click.native="goToPublicationsPage"
        v-model="value">{{ ok }}</q-knob>
</template>

<script>
    import QKnob from 'quasar-framework/src/components/knob/QKnob'
    export default {
        name: 'GlobalPublishInfo',
        components: {QKnob},
        methods: {
            goToPublicationsPage () {
                // this.$router.push({name: 'publications'})
            }
        },
        computed: {
            ok () {
                if (this.value === this.max) {
                    return "ok"
                }
                return this.max - this.value
            },
            allPublishableComponents () {
                const all = this.$store.getters.publishableComponents
                let values = [];
                for (let prop in all) {
                    if (all.hasOwnProperty(prop)) {
                        values = [...values, ...all[prop]];
                    }
                }

                return values
            },
            min () {
                return 0
            },
            max () {
                return this.allPublishableComponents.length
            },
            value () {
                return this.allPublishableComponents.filter(c => c.publicationInformation.status === 'Published').length
            }
        }
    }
</script>

<style scoped>

</style>